import { csConstants, siteConstants } from "../../constants";
import { csServices } from "../../services";
import { alertActions } from ".";

const listGuidance = () => {
  const request = () => {
    return {
      type: csConstants.LIST_GUIDANCE_REQUEST,
      payload: null,
    };
  }

  const success = (data) => {
    return {
      type: csConstants.LIST_GUIDANCE_SUCCESS,
      payload: { data },
    };
  }

  const failure = () => {
    return {
      type: csConstants.LIST_GUIDANCE_FAILURE,
      payload: null,
    };
  }

  return dispatch => {
    dispatch(request());
    csServices.listGuidance()
      .then(response => {
        const data = response.data;
        dispatch(success(data));
      })
      .catch(error => {
        if (error.response)
          dispatch(alertActions.error(error.response.data.detail || siteConstants.ERROR_MSG_SERVER_COMMUNICATION));
        else
          dispatch(alertActions.error(siteConstants.ERROR_MSG_SERVER_COMMUNICATION))

        dispatch(failure());
      });
  };
}

const updateGuidance = (file) => {
  const request = (file) => {
    return {
      type: csConstants.UPDATE_GUIDANCE_REQUEST,
      payload: {
        file,
      },
    };
  }

  const success = (data) => {
    return {
      type: csConstants.UPDATE_GUIDANCE_SUCCESS,
      payload: { data },
    };
  }

  const failure = () => {
    return {
      type: csConstants.UPDATE_GUIDANCE_FAILURE,
      payload: null,
    };
  }

  return dispatch => {
    dispatch(request(file));
    csServices.updateGuidance(file)
      .then(response => {
        const data = response.data;
        dispatch(success(data));
      })
      .catch(error => {
        if (error.response)
          dispatch(alertActions.error(error.response.data.detail || siteConstants.ERROR_MSG_SERVER_COMMUNICATION));
        else
          dispatch(alertActions.error(siteConstants.ERROR_MSG_SERVER_COMMUNICATION))

        dispatch(failure());
      });
  };
}

const listReports = (startDate, endDate) => {
  const request = (startDate, endDate) => {
    return {
      type: csConstants.LIST_REPORTS_REQUEST,
      payload: {
        startDate,
        endDate,
      },
    };
  }

  const success = (data) => {
    return {
      type: csConstants.LIST_REPORTS_SUCCESS,
      payload: { data },
    };
  }

  const failure = () => {
    return {
      type: csConstants.LIST_REPORTS_FAILURE,
      payload: null,
    };
  }

  return dispatch => {
    dispatch(request(startDate, endDate));
    csServices.listReports(startDate, endDate)
      .then(response => {
        const data = response.data;
        dispatch(success(data));
      })
      .catch(error => {
        if (error.response)
          dispatch(alertActions.error(error.response.data.detail || siteConstants.ERROR_MSG_SERVER_COMMUNICATION));
        else
          dispatch(alertActions.error(siteConstants.ERROR_MSG_SERVER_COMMUNICATION))

        dispatch(failure());
      });
  };
}

const validateReport = (file) => {
  const request = (file) => {
    return {
      type: csConstants.VALIDATE_REPORT_REQUEST,
      payload: {
        file,
      },
    };
  }

  const success = (data) => {
    return {
      type: csConstants.VALIDATE_REPORT_SUCCESS,
      payload: { data },
    };
  }

  const failure = () => {
    return {
      type: csConstants.VALIDATE_REPORT_FAILURE,
      payload: null,
    };
  }

  return dispatch => {
    dispatch(request(file));
    csServices.validateReport(file)
      .then(response => {
        const data = response.data;
        dispatch(success(data));
      })
      .catch(error => {
        if (error.response)
          dispatch(alertActions.error(error.response.data.detail || siteConstants.ERROR_MSG_SERVER_COMMUNICATION));
        else
          dispatch(alertActions.error(siteConstants.ERROR_MSG_SERVER_COMMUNICATION))

        dispatch(failure());
      });
  };
}

const getReportValidationStatus = (reportId) => {
  const request = (reportId) => {
    return {
      type: csConstants.VALIDATION_STATUS_REQUEST,
      payload: { reportId },
    };
  }

  const success = (data) => {
    return {
      type: csConstants.VALIDATION_STATUS_SUCCESS,
      payload: { data },
    };
  }

  const failure = (errorMessage) => {
    return {
      type: csConstants.VALIDATION_STATUS_FAILURE,
      payload: null,
    };
  }

  return dispatch => {
    dispatch(request(reportId));
    csServices.retrieveReport(reportId)
      .then(response => {
        const data = response.data;
        dispatch(success(data));
      })
      .catch(error => {
        if (error.response)
          dispatch(alertActions.error(error.response.data.detail || siteConstants.ERROR_MSG_SERVER_COMMUNICATION));
        else
          dispatch(alertActions.error(siteConstants.ERROR_MSG_SERVER_COMMUNICATION))

        dispatch(failure());
      });
  }
}

const processReport = (reportId) => {
  const request = (reportId) => {
    return {
      type: csConstants.PROCESS_REPORT_REQUEST,
      payload: { reportId },
    };
  }

  const success = (data) => {
    return {
      type: csConstants.PROCESS_REPORT_SUCCESS,
      payload: { data },
    };
  }

  const failure = (errorMessage) => {
    return {
      type: csConstants.PROCESS_REPORT_FAILURE,
      payload: null,
    };
  }

  return dispatch => {
    dispatch(request(reportId));
    csServices.processReport(reportId)
      .then(response => {
        const data = response.data;
        dispatch(success(data));
      })
      .catch(error => {
        if (error.response)
          dispatch(alertActions.error(error.response.data.detail || siteConstants.ERROR_MSG_SERVER_COMMUNICATION));
        else
          dispatch(alertActions.error(siteConstants.ERROR_MSG_SERVER_COMMUNICATION))

        dispatch(failure());
      });
  }
}

const retrieveReport = (reportId) => {
  const request = (reportId) => {
    return {
      type: csConstants.RETRIEVE_REPORT_REQUEST,
      payload: { reportId },
    };
  }

  const success = (data) => {
    return {
      type: csConstants.RETRIEVE_REPORT_SUCCESS,
      payload: { data },
    };
  }

  const failure = (errorMessage) => {
    return {
      type: csConstants.RETRIEVE_REPORT_FAILURE,
      payload: null,
    };
  }

  return dispatch => {
    dispatch(request(reportId));
    csServices.retrieveReport(reportId)
      .then(response => {
        const data = response.data;
        dispatch(success(data));
      })
      .catch(error => {
        if (error.response)
          dispatch(alertActions.error(error.response.data.detail || siteConstants.ERROR_MSG_SERVER_COMMUNICATION));
        else
          dispatch(alertActions.error(siteConstants.ERROR_MSG_SERVER_COMMUNICATION))

        dispatch(failure());
      });
  }
}

const listAssessmentReportTemplates = () => {
  const request = () => {
    return {
      type: csConstants.LIST_ASSESSMENT_REPORT_TEMPLATES_REQUEST,
      payload: null,
    };
  }

  const success = (data) => {
    return {
      type: csConstants.LIST_ASSESSMENT_REPORT_TEMPLATES_SUCCESS,
      payload: { data },
    };
  }

  const failure = (errorMessage) => {
    return {
      type: csConstants.LIST_ASSESSMENT_REPORT_TEMPLATES_FAILURE,
      payload: null,
    };
  }

  return dispatch => {
    dispatch(request());
    csServices.listAssessmentReportTemplates()
      .then(response => {
        const data = response.data;
        dispatch(success(data));
      })
      .catch(error => {
        if (error.response)
          dispatch(alertActions.error(error.response.data.detail || siteConstants.ERROR_MSG_SERVER_COMMUNICATION));
        else
          dispatch(alertActions.error(siteConstants.ERROR_MSG_SERVER_COMMUNICATION))

        dispatch(failure());
      });
  }
}

const createAssessmentReportPreview = (reportId, templateId) => {
  const request = (reportId, templateId) => {
    return {
      type: csConstants.CREATE_ASSESSMENT_REPORT_PREVIEW_REQUEST,
      payload: {
        reportId,
        templateId,
      },
    };
  }

  const success = (data) => {
    return {
      type: csConstants.CREATE_ASSESSMENT_REPORT_PREVIEW_SUCCESS,
      payload: { data },
    };
  }

  const failure = (errorMessage) => {
    return {
      type: csConstants.CREATE_ASSESSMENT_REPORT_PREVIEW_FAILURE,
      payload: null,
    };
  }

  return dispatch => {
    dispatch(request(reportId, templateId));
    csServices.createAssessmentReportPreview(reportId, templateId)
      .then(response => {
        const data = response.data;
        dispatch(success(data));
      })
      .catch(error => {
        if (error.response)
          dispatch(alertActions.error(error.response.data.detail || siteConstants.ERROR_MSG_SERVER_COMMUNICATION));
        else
          dispatch(alertActions.error(siteConstants.ERROR_MSG_SERVER_COMMUNICATION))

        dispatch(failure());
      });
  }
}

export const csActions = {
  listGuidance,
  updateGuidance,
  listReports,
  validateReport,
  getReportValidationStatus,
  processReport,
  retrieveReport,
  listAssessmentReportTemplates,
  createAssessmentReportPreview,
};